var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSocialFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "nonzero",
    d: "M9.66666667,2.66666667 L11.6666667,2.66666667 C11.8506667,2.66666667 12,2.51733333 12,2.33333333 L12,0.333333333 C12,0.149333333 11.8506667,0 11.6666667,0 L9.66666667,0 C7.64533333,0 6,1.64466667 6,3.66666667 L6,6 L3.66666667,6 C3.48266667,6 3.33333333,6.14933333 3.33333333,6.33333333 L3.33333333,8.33333333 C3.33333333,8.51733333 3.48266667,8.66666667 3.66666667,8.66666667 L6,8.66666667 L6,15.6666667 C6,15.8506667 6.14933333,16 6.33333333,16 L8.33333333,16 C8.51733333,16 8.66666667,15.8506667 8.66666667,15.6666667 L8.66666667,8.66666667 L11,8.66666667 C11.1433333,8.66666667 11.2706667,8.57466667 11.3166667,8.43866667 L11.9833333,6.43866667 C12.0173333,6.33733333 12,6.22533333 11.9373333,6.138 C11.874,6.05133333 11.774,6 11.6666667,6 L8.66666667,6 L8.66666667,3.66666667 C8.66666667,3.11533333 9.11533333,2.66666667 9.66666667,2.66666667 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FFF",
    fillOpacity: 0.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialFacebook);
export default __webpack_public_path__ + "static/media/ic-social-facebook.59f9f7853a2d2739a90837fd412eb35d.svg";
export { ForwardRef as ReactComponent };